// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3IYOK","detailsBorder":"styles_detailsBorder__Vph0T"};